<script>
export default {
  name: 'Started-blog'
}
</script>

<template>
  <!--START GET STARTED-->
  <section class="section section-lg bg-get-start" :style="{'background': 'url(' + require('@/assets/images/banner.6.png') + ')'}">
    <div class="bg-overlay"></div>
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-1 text-left">
          <h1 class="get-started-title text-white">Con DIU tienes una <br>GRAN OPORTUNIDAD DE INVERSIÓN</h1>
          <div class="section-title-border margin-t-20 bg-white"></div>
          <h3
            class="section-subtitle font-secondary text-white text-left padding-t-30"
          >Aquí puedes adquirir un negocio comprobado desde<br> UDS 85.000 y obtener múltiples beneficios en nuestra red de franquicias<br><br><p>¡Una franquicia en el mercado puede costar en promedio USD 100.000!</p>
</h3>
          
          <a href="#contact" class="btn btn-bg-white margin-t-20">
            Contáctanos
            <i class="mdi mdi-arrow-right"></i>
          </a>
        </div>
      </div>
    </div>
  </section>
  <!--END GET STARTED-->
</template>